import React from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'antd';

const PageHeader = (props) => {
    return (
        <Row span={24} className="pb-10 d-none print-" style={{backgroundColor:'white', minHeight:'120px', overflow:'none'}} >
        <Col span={4}  className="text-center" style={{marginTop:'2px', marginBottom:'2px', height:'110px', fontSize:'7px'}}>
        <img 
            src={process.env.REACT_APP_SERVER_URL + props.user.links ?? ''}
            className="m-0 p-0" 
            width='100px'
            height='85px'
            alt='admission' 
            onError={(e)=>{e.target.onerror=null; e.target.src=process.env.REACT_APP_PICS} }
        />
        </Col>
        <Col span={5}   style={{ marginBottom:'4px', paddingLeft:'10px'}}>
        <div className='my-1'>
            <small className='pull-left' style={{maxHeight:'100px', height:'100px', minHeight:'100px'}}>
                <b style={{width:"200px", height:"80%", maxHeight:"100px", fontSize:"0.9vw", fontSize:'9px', overflow:'unset'}}>
                    {props.hasOwnProperty('user') &&
                    props.user !== undefined && 
                    props.user.hasOwnProperty('name') ?
                     props.user.name  : process.env.REACT_APP_ADDR}<br/>
                    {props.hasOwnProperty('user') &&
                    props.user !== undefined && 
                    props.user.hasOwnProperty('address') ?
                    props.user.address  : process.env.REACT_APP_ADDR2}<br/>
                    {props.hasOwnProperty('user') &&
                    props.user !== undefined && 
                    props.user.hasOwnProperty('phone1') ?
                    props.user.phone1 : process.env.REACT_APP_PHONE1}{" "}
                    {props.hasOwnProperty('user') &&
                    props.user !== undefined && 
                    props.user.hasOwnProperty('phone2') ? 
                    props.user.phone2 : process.env.REACT_APP_PHONE2}<br/>
                    {props.hasOwnProperty('user') &&
                    props.user !== undefined && 
                    props.user.hasOwnProperty('email') ?
                    props.user.email : process.env.REACT_APP_EMAIL}<br/>
                </b>
            </small>
        </div>
        </Col>
        <Col span={7}></Col>
        <Col span={4} style={{textAlign:'right', fontSize:'9px'}}>
        <div className='my-2'>
            <small className='pull-right '>
                <b>
                StreSERT Integrated Limited<br/>
                2nd Floor, ACHILLES PLACE<br/>
                11, Maye Street<br/>
                Off Commercial Avenue
                 <br/>
                 Yaba, Lagos State<br/> 
                 +234 906 8808 021<br/>
                 info@stresertintegrated.com<br/>
                </b>
               
            </small>
        </div>
        </Col>
        <Col span={4} className="text-center" style={{ marginTop:'1px'}}>
        <img 
            src={process.env.PUBLIC_URL + process.env.REACT_APP_LOGO2}
            className="m-0 p-0" 
            width='100px'
            height='85px'
            alt='admission' 
            onError={(e)=>{e.target.onerror=null; e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'} }
        />
        </Col> 
  </Row>
    )
}

const mapStateToProps = (state) => ({
    user:state.userReducer
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader)
